export default {
  methods: {
    can(permission) {
      const perms = this.$store && this.$store.getters.permissions;
      if (!perms) {
        return false;
      }

      if (Array.isArray(perms)) {
        return perms.includes(permission);
      }

      try {
        const parsed = JSON.parse(perms);
        if (Array.isArray(parsed)) {
          return parsed.includes(permission);
        }
      } catch (e) {
        // stored as a comma-separated string
      }

      return String(perms)
        .split(",")
        .map(item => item.trim())
        .includes(permission);
    }
  }
};
